export default function UserWorkExperience({ openModal, experiences, industries, jobTypes, lang }: any) {
  const getIndustryName = (id: number) =>
    industries.find((i: any) => i.id == id)?.name || "-";

  const getJobTypeName = (id: number) =>
    jobTypes.find((j: any) => j.id == id)?.name || "-";

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Pengalaman Kerja" : "Work Experience"}</h3>
        <button
          onClick={() => openModal("work")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      {experiences.map((exp: any, idx: number) => (
        <div key={idx} className="p-2 rounded-xl border-2 space-y-1">
          <h4 className="text-lg font-semibold">{exp.jobTitle}</h4>
          <h4 className="text-lg font-semibold">{exp.companyName}</h4>

          <p className="text-sm">{getIndustryName(exp.industry)}</p>
          <p className="text-sm">{getJobTypeName(exp.employmentType)}</p>

          <p className="text-sm text-gray-500">
            {lang === "id"
              ? `${exp.startDate} – ${exp.current ? "Sekarang" : exp.endDate || "-"}`
              : `${exp.startDate} – ${exp.current ? "Present" : exp.endDate || "-"}`
            }
          </p>
          <div className="py-2">
            <p>Key Responsibilities</p>
            <div
              className="text-gray-700 text-md [&_ul]:list-disc [&_ul]:ms-5 [&_ol]:list-decimal [&_ol]:ms-5 [&_p]:my-0"
              dangerouslySetInnerHTML={{
                __html: exp.responsibilities || "-",
              }}
            />
          </div>
          <div className="py-2">
            <p>Achievements</p>
            <div
              className="text-gray-700 text-md [&_ul]:list-disc [&_ul]:ms-5 [&_ol]:list-decimal [&_ol]:ms-5 [&_p]:my-0"
              dangerouslySetInnerHTML={{
                __html: exp.achievements || "-",
              }}
            />
          </div>


        </div>
      ))}
    </div>
  );
}
